/** Le seul environnement où l'API se devine : celui où elle tourne sur la même machine. */
const LOCAL_API_BASE_URL = 'http://localhost:3000';
/**
 * L'URL de l'API, lue dans les variables substituées **à la compilation** : ce qui n'a pas
 * été posé au build ne peut plus l'être ensuite — ni sur la tablette, ni sur le poste de
 * bureau.
 *
 * ⚠️ Liste blanche, comme le `NODE_ENV` de l'API (D23) : seul un build de développement
 * retombe sur la boucle locale. Un bundle de production construit sans `VITE_API_URL`
 * embarquerait `http://localhost:3000` : chaque appel viserait la machine qui ouvre l'app —
 * la tablette sur le terrain, le poste de l'utilisateur au bureau — en silence. Une variable
 * **déclarée vide** est le même défaut sous une autre forme : `'' ?? défaut` rend `''`, donc
 * des appels relatifs à l'origine du front.
 */
export function readApiBaseUrl(env) {
    // Une espace en tête ou en fin ne se voit ni dans un panneau de variables, ni dans un
    // journal de build ; elle rendrait pourtant toutes les requêtes invalides.
    const configured = env.VITE_API_URL?.trim() ?? '';
    if (configured !== '')
        return configured;
    if (env.DEV)
        return LOCAL_API_BASE_URL;
    throw new Error('Démarrage impossible : `VITE_API_URL` n’a pas été posée à la construction de ce bundle. ' +
        'Elle ne peut pas l’être après coup — Vite substitue sa valeur à la compilation.');
}
//# sourceMappingURL=api-base-url.js.map